"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicWowLinkConverter = void 0;
var fuse_js_1 = __importDefault(require("fuse.js"));
var BasicWowLinkConverter = /** @class */ (function () {
    function BasicWowLinkConverter(config) {
        this.config_ = config;
    }
    BasicWowLinkConverter.prototype._populateSuggestions = function (req) {
        var searchOpt = {
            includeScore: true,
            findAllMatches: true,
            threshold: 0.2,
            keys: ["fullUrl"],
        };
        var searchList = [];
        for (var wowUrl in this.config_.fetcherResponse.wowMapping) {
            var fullUrl = this.config_.fetcherResponse.wowMapping[wowUrl];
            searchList.push({ fullUrl: fullUrl, wowUrl: wowUrl, score: 0 });
        }
        var fuse = new fuse_js_1.default(searchList, searchOpt);
        var searchRes = [];
        fuse
            .search(req.wowUrl)
            .forEach(function (res) {
            searchRes.push({
                wowUrl: res.item.wowUrl,
                fullUrl: res.item.fullUrl,
                score: res.score,
            });
        });
        return searchRes;
    };
    BasicWowLinkConverter.prototype.convert = function (req) {
        var lookup = this.config_.fetcherResponse.wowMapping;
        var wowlink = req.wowUrl;
        var res = {
            fullUrl: "/",
        };
        if (wowlink in lookup) {
            res.fullUrl = lookup[wowlink];
        }
        res.searchRanking = this._populateSuggestions(req);
        return res;
    };
    return BasicWowLinkConverter;
}());
exports.BasicWowLinkConverter = BasicWowLinkConverter;
